<template>
	<div class="phantom-container">
		<notifications classes="master-notifications" position="top left" group="default" />
		<router-view />
		<loader />
	</div>
</template>

<script>
import loader from '@/common/components/loader'
export default {
	name: 'App',
	components: {
		loader
	},
	mounted () {
		console.log('[Patrimoffice] v1.3.0')
		if (this.$route.name !== 'Login' && this.$route.name !== 'Subscribe') {
			if (!this.$store.getters['isUser']) {
				this.$router.push({name: 'Subscribe'})
			}
		}
	},
	watch: {
		$route (to, from) {
			this.$ga.page(to.fullPath)
		}
	}
}
</script>

<style lang="scss">
	@import '~@/common/assets/sass/common.scss';
	@import '~@/assets/sass/master.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue